export default __webpack_public_path__ + "static/media/transform-lifes-1-costa-rica.2b4811ec.png";